import { html, css, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class TicketsInputComponent extends NexusComponent {
    static shadowRootOptions = { ...LitElement.shadowRootOptions, mode: 'open', delegatesFocus: true };
    static properties = {
        value: {
            type: Number,
            attribute: 'value',
            reflect: true,
        },
        donation: {
            type: Boolean, // if attribute is present on element, then true. If not present, it's false
            attribute: 'donation',
            reflect: true,
        },
        // step: {
        //     type: Number,
        //     attribute: 'step',
        //     reflect: true,
        // },
        // current: {
        //     attribute: 'current',
        //     reflect: true,
        // }
    };
    constructor() {
        super();
        this.value;
        this.donation;
        // this.current;
        this.addEventListener('click', this.handleClick);
    }
    connectedCallback() {
        super.connectedCallback();
        this.querySelectorAll('input').forEach((input) => {
            input.addEventListener('input', (event) => {
                this.handleInputChange(event);
            });
        });
    }
    handleInputChange(event) {
        console.log('handleInputChange', event, event.target);
        let input = event.target;
        if (input) {
            if (parseInt(input.value) > parseInt(input.max)) {
                input.value = input.max;
            }
            if (parseInt(input.value) <= parseInt(input.min)) {
                input.value = input.min;
            }

        }
        this.handleInputRangeNavigation(input);
    }

    /**
     * Handle range input navigation (decrease and increase buttons) for synchronously loaded inputs
     * ('left side' ticket items that can be chosen).
     * For ticket order overview the handling is different: a reactive js template
     * see getIncreaseButtonDisabledState; getIncreaseButtonEnabledState for ticket order overview input button disabled state
     * @param {Element} input 
     */
    handleInputRangeNavigation(input) {
        let decrease = this.querySelector('.ticket-option-button-decrease');
        let increase = this.querySelector('.ticket-option-button-increase');
        if (input) {
            let min = input.min;
            let max = input.max;
            if (min === input.value) {
                if (decrease) {
                    decrease.disabled = true;
                }
                if (increase) {
                    increase.disabled = false;
                }
            }

            if (parseInt(input.value) > parseInt(min)) {
                decrease.disabled = false;
            }

            if (parseInt(input.value) < parseInt(max)) {
                increase.disabled = false;
            }

            if (max === input.value) {
                if (increase) {
                    increase.disabled = true;
                }
            }
        }
    }

    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
                display: grid;  /* or display: block; */
                position: relative;
                margin: 0;
			}
		`;
    }

    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        console.log('attributeChangedCallback', name, _old, value);

        // for a sync input decrease and increase button setup this method would be a starting place

        if (name === 'value') {
            let decrease = this.querySelector('.ticket-option-button-decrease');
            let increase = this.querySelector('.ticket-option-button-increase');
            let input = this.querySelector('.ticket-option-input');
            if (input) {
                let min = input.min;
                let max = input.max;
                console.log('min', min);
                console.log('max', max);
                console.log('value', value);
                if (min == value) {
                    if (decrease) {
                        decrease.disabled = true;
                    }
                    if (increase) {
                        increase.disabled = false;
                    }
                }

                if (parseInt(value) > parseInt(min)) {
                    decrease.disabled = false;
                }

                if (parseInt(value) < parseInt(max)) {
                    increase.disabled = false;
                }

                if (max == value) {
                    if (increase) {
                        increase.disabled = true;
                    }
                }
            }
        }
    }

    handleSlotChange(event) {
        console.log('handleSlotChange', event)
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });

    }

    /**
     * 
     * @param {PointerEvent} event 
     */
    handleClick(event) {
        console.log('handleClick', event);
        this.handleAmountOption(event);
    }

    handleAmountOption(event) {
        console.log('handleAmountOption method event target is', event.target);
        // event.target.setAttribute('current', "");
        let amountOption = event.target.closest('.ticket-option-amount');
        if (amountOption) {
            let input = amountOption.querySelector('.ticket-option-input');
            console.log('amountOption input:', input);
            if (input) {
                if (event.target.classList.contains('ticket-option-button-decrease')) {
                    console.log('Decrease');
                    if (input.min) {
                        let min = parseInt(input.min);
                        let value = parseInt(input.value);
                        if (min === 0 || min > 0) {
                            // if (value > min) {
                            this.value = parseInt(input.value);
                            this.value -= 1;
                            if (this.value < min) {
                                this.value = min;
                            }
                            input.value = this.value;
                            this.triggerEventOnElement('input', input);
                            // }
                        } else {

                        }
                        // this.triggerEventOnElement('input', input);
                        // this.triggerEventOnElement('input', this);
                        console.log('value after check, and min', value, min);
                    }
                }
                if (event.target.classList.contains('ticket-option-button-increase')) {
                    console.log('Increase');
                    if (input.max) {
                        let max = parseInt(input.max);
                        let value = parseInt(input.value);
                        if (max) {
                            if (value < max) {
                                this.value = parseInt(input.value);
                                this.value += 1;
                                input.value = this.value;
                                this.triggerEventOnElement('input', input);
                            }
                            if (value > max) {
                                // this.value = parseInt(input.value);
                                // // this.value -= 1;
                                this.value = input.max;
                                input.value = input.max;
                                this.triggerEventOnElement('input', input);
                            }
                        }
                        // this.triggerEventOnElement('input', input);
                        // this.triggerEventOnElement('input', this);
                        console.log('value after check, and max', value, max);
                    }
                }
            }
        }
    }

    render() {
        return html`
            <div class="tickets-step" component-loaded>
                <slot @slotchange="${this.handleSlotChange}">...</slot>
                
            </div>
        `;
        // Step debug: ${this.step}
    }
}

window.customElements.define('tickets-input', TicketsInputComponent);